import { palette } from '../theme';

const { base, grey, purple } = palette.primitives;

export const H = {
  brandGradient: 'linear-gradient(135deg, #667EEA 0%, #9A218C 100%)',
  // Header chrome
  bg: base.white,
  height: 56,
  /** Max height for logos — 45% of header height */
  clientLogoMaxHeight: 0.45,
  border: '#E2E2E2',
  separator: '#E2E2E2',
  separatorHeight: 24,
  text: grey.grey800,
  textMuted: grey.grey500,

  // Module selector trigger
  moduleBg: purple.purple400,
  moduleBorder: purple.purple200,
  moduleText: base.white,

  // Module dropdown
  dropdownBg: base.white,
  dropdownBorder: grey.grey200,
  dropdownText: grey.grey500,
  dropdownAccent: purple.purple500,
  dropdownActiveBg: purple.purple0,
  dropdownActiveBorder: purple.purple200,
  dropdownHoverBg: grey.grey50,

  // Drawer (mobile)
  drawerBg: base.white,
  drawerText: grey.grey800,
  drawerTextMuted: grey.grey500,
  drawerBorder: grey.grey200,
  drawerButtonBg: grey.grey0,
  drawerButtonBorder: grey.grey200,
  drawerMenuBg: grey.grey50,
  drawerModuleActiveBg: purple.purple0
} as const;
